export default __webpack_public_path__ + "static/how-to-enrol-a10577debc2846ffe4bf55ddbffab770.jpg";